import { AvatarActive as FluentAvatarActive, AvatarAppearance as FluentAvatarAppearance, AvatarColor as FluentAvatarColor, AvatarNamedColor as FluentAvatarNamedColor, AvatarShape as FluentAvatarShape, AvatarSize as FluentAvatarSize } from "@fluentui/web-components";
/** Active state values for {@link Avatar}. */
export const AvatarActives = { ...FluentAvatarActive };
export const AvatarActive = AvatarActives;
/** Appearance values for {@link Avatar}. */
export const AvatarAppearances = { ...FluentAvatarAppearance };
export const AvatarAppearance = AvatarAppearances;
/** Color scheme values for {@link Avatar}. */
export const AvatarColors = { ...FluentAvatarColor };
export const AvatarColor = AvatarColors;
/** Named color values for {@link Avatar}. */
export const AvatarNamedColors = { ...FluentAvatarNamedColor };
export const AvatarNamedColor = AvatarNamedColors;
/** Shape values for {@link Avatar}. */
export const AvatarShapes = { ...FluentAvatarShape };
export const AvatarShape = AvatarShapes;
/** Size values for {@link Avatar}. */
export const AvatarSizes = { ...FluentAvatarSize };
export const AvatarSize = AvatarSizes;
//# sourceMappingURL=avatar.options.js.map